import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AppShellModule } from '@priva/appshell';
import { NotificationStatus, PrivaNotificationsService } from '@priva/notifications';

import { ToasterNotification } from 'shared/notifications';

import { RootState } from './app.config';
import { DynamicComponentHolderComponent } from './components/dynamic-component-holder/dynamic-component-holder.component';
import { CurrentUserActions } from './current-user/state';
import { LogUserTraitsDirective } from './shared/analytics/log-user-traits.directive';
import { removeNotification } from './state/app.actions';
import { selectNotification } from './state/app.selectors';

@Component({
    templateUrl: 'app-main.component.html',
    // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [AppShellModule, LogUserTraitsDirective, DynamicComponentHolderComponent],
})
export class AppMainComponent implements OnDestroy {
    private readonly unsubscribe = new Subject<void>();

    constructor(
        private readonly store: Store<RootState>,
        private readonly notificationService: PrivaNotificationsService,
    ) {
        this.store.dispatch(CurrentUserActions.loadCurrentUser());
        this.store
            .pipe(select(selectNotification), takeUntil(this.unsubscribe))
            .subscribe((notification: ToasterNotification | undefined) => {
                if (notification) {
                    switch (notification.status) {
                        case NotificationStatus.Danger:
                            this.notificationService.toaster.error(notification.message, {
                                behavior: 'transient',
                            });
                            break;
                        case NotificationStatus.Info:
                            this.notificationService.toaster.info(notification.message, {
                                behavior: 'transient',
                            });
                            break;
                        case NotificationStatus.Success:
                            this.notificationService.toaster.success(notification.message, {
                                behavior: 'transient',
                            });
                            break;
                        case NotificationStatus.Warning:
                            this.notificationService.toaster.warning(notification.message, {
                                behavior: 'transient',
                            });
                            break;
                        default:
                            break;
                    }

                    this.store.dispatch(removeNotification());
                }
            });
    }

    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
